//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/halo/invitations.proto (package dxos.halo.invitations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Invitation_AuthMethod } from "../client/invitation_pb.js";
import { file_dxos_client_invitation } from "../client/invitation_pb.js";
import type { TimeframeVector } from "../echo/timeframe_pb.js";
import { file_dxos_echo_timeframe } from "../echo/timeframe_pb.js";
import type { Credential, DeviceProfileDocument, ProfileDocument, SpaceMember_Role } from "./credentials_pb.js";
import { file_dxos_halo_credentials } from "./credentials_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/halo/invitations.proto.
 */
export const file_dxos_halo_invitations: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_dxos_client_invitation, file_dxos_echo_timeframe, file_dxos_halo_credentials, file_dxos_keys]);

/**
 * @generated from message dxos.halo.invitations.InvitationOptions
 */
export type InvitationOptions = Message<"dxos.halo.invitations.InvitationOptions"> & {
  /**
   * / Role of the peer.
   *
   * @generated from field: dxos.halo.invitations.InvitationOptions.Role role = 1;
   */
  role: InvitationOptions_Role;
};

/**
 * Describes the message dxos.halo.invitations.InvitationOptions.
 * Use `create(InvitationOptionsSchema)` to create a new message.
 */
export const InvitationOptionsSchema: GenMessage<InvitationOptions> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 0);

/**
 * @generated from enum dxos.halo.invitations.InvitationOptions.Role
 */
export enum InvitationOptions_Role {
  /**
   * Sentinel so neither real role is the proto3 default (which is stripped on the wire,
   * causing the receiver to see `role === undefined` and reject with InvalidInvitationExtensionRoleError).
   *
   * @generated from enum value: INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: GUEST = 1;
   */
  GUEST = 1,

  /**
   * @generated from enum value: HOST = 2;
   */
  HOST = 2,
}

/**
 * Describes the enum dxos.halo.invitations.InvitationOptions.Role.
 */
export const InvitationOptions_RoleSchema: GenEnum<InvitationOptions_Role> = /*@__PURE__*/
  enumDesc(file_dxos_halo_invitations, 0, 0);

/**
 * @generated from message dxos.halo.invitations.IntroductionRequest
 */
export type IntroductionRequest = Message<"dxos.halo.invitations.IntroductionRequest"> & {
  /**
   * / Guest's profile.
   *
   * @generated from field: optional dxos.halo.credentials.ProfileDocument profile = 1;
   */
  profile?: ProfileDocument;

  /**
   * @generated from field: optional string invitation_id = 2;
   */
  invitationId?: string;
};

/**
 * Describes the message dxos.halo.invitations.IntroductionRequest.
 * Use `create(IntroductionRequestSchema)` to create a new message.
 */
export const IntroductionRequestSchema: GenMessage<IntroductionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 1);

/**
 * @generated from message dxos.halo.invitations.IntroductionResponse
 */
export type IntroductionResponse = Message<"dxos.halo.invitations.IntroductionResponse"> & {
  /**
   * @generated from field: dxos.client.services.Invitation.AuthMethod auth_method = 1;
   */
  authMethod: Invitation_AuthMethod;

  /**
   * / Present when auth_method is KNOWN_PUBLIC_KEY.
   *
   * @generated from field: optional bytes challenge = 2;
   */
  challenge?: Uint8Array;

  /**
   * / Only present for testing invitation types.
   *
   * @generated from field: optional dxos.keys.PublicKey space_key = 100;
   */
  spaceKey?: PublicKey;
};

/**
 * Describes the message dxos.halo.invitations.IntroductionResponse.
 * Use `create(IntroductionResponseSchema)` to create a new message.
 */
export const IntroductionResponseSchema: GenMessage<IntroductionResponse> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 2);

/**
 * @generated from message dxos.halo.invitations.AuthenticationRequest
 */
export type AuthenticationRequest = Message<"dxos.halo.invitations.AuthenticationRequest"> & {
  /**
   * / Present when auth_method is SHARED_SECRET.
   *
   * @generated from field: optional string auth_code = 1;
   */
  authCode?: string;

  /**
   * / Present when auth_method is KNOWN_PUBLIC_KEY.
   *
   * @generated from field: optional bytes signed_challenge = 2;
   */
  signedChallenge?: Uint8Array;
};

/**
 * Describes the message dxos.halo.invitations.AuthenticationRequest.
 * Use `create(AuthenticationRequestSchema)` to create a new message.
 */
export const AuthenticationRequestSchema: GenMessage<AuthenticationRequest> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 3);

/**
 * @generated from message dxos.halo.invitations.AuthenticationResponse
 */
export type AuthenticationResponse = Message<"dxos.halo.invitations.AuthenticationResponse"> & {
  /**
   * @generated from field: optional dxos.halo.invitations.AuthenticationResponse.Status status = 1;
   */
  status?: AuthenticationResponse_Status;
};

/**
 * Describes the message dxos.halo.invitations.AuthenticationResponse.
 * Use `create(AuthenticationResponseSchema)` to create a new message.
 */
export const AuthenticationResponseSchema: GenMessage<AuthenticationResponse> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 4);

/**
 * @generated from enum dxos.halo.invitations.AuthenticationResponse.Status
 */
export enum AuthenticationResponse_Status {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: INVALID_OTP = 1;
   */
  INVALID_OTP = 1,

  /**
   * @generated from enum value: INVALID_OPT_ATTEMPTS = 2;
   */
  INVALID_OPT_ATTEMPTS = 2,

  /**
   * @generated from enum value: INTERNAL_ERROR = 3;
   */
  INTERNAL_ERROR = 3,

  /**
   * @generated from enum value: INVALID_SIGNATURE = 4;
   */
  INVALID_SIGNATURE = 4,
}

/**
 * Describes the enum dxos.halo.invitations.AuthenticationResponse.Status.
 */
export const AuthenticationResponse_StatusSchema: GenEnum<AuthenticationResponse_Status> = /*@__PURE__*/
  enumDesc(file_dxos_halo_invitations, 4, 0);

/**
 * @generated from message dxos.halo.invitations.DeviceAdmissionRequest
 */
export type DeviceAdmissionRequest = Message<"dxos.halo.invitations.DeviceAdmissionRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey device_key = 1;
   */
  deviceKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey control_feed_key = 2;
   */
  controlFeedKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey data_feed_key = 3;
   */
  dataFeedKey?: PublicKey;

  /**
   * @generated from field: optional dxos.halo.credentials.DeviceProfileDocument profile = 4;
   */
  profile?: DeviceProfileDocument;
};

/**
 * Describes the message dxos.halo.invitations.DeviceAdmissionRequest.
 * Use `create(DeviceAdmissionRequestSchema)` to create a new message.
 */
export const DeviceAdmissionRequestSchema: GenMessage<DeviceAdmissionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 5);

/**
 * @generated from message dxos.halo.invitations.SpaceAdmissionRequest
 */
export type SpaceAdmissionRequest = Message<"dxos.halo.invitations.SpaceAdmissionRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey identity_key = 1;
   */
  identityKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey device_key = 2;
   */
  deviceKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey control_feed_key = 3;
   */
  controlFeedKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey data_feed_key = 4;
   */
  dataFeedKey?: PublicKey;
};

/**
 * Describes the message dxos.halo.invitations.SpaceAdmissionRequest.
 * Use `create(SpaceAdmissionRequestSchema)` to create a new message.
 */
export const SpaceAdmissionRequestSchema: GenMessage<SpaceAdmissionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 6);

/**
 * @generated from message dxos.halo.invitations.DelegateSpaceInvitation
 */
export type DelegateSpaceInvitation = Message<"dxos.halo.invitations.DelegateSpaceInvitation"> & {
  /**
   * @generated from field: string invitation_id = 1;
   */
  invitationId: string;

  /**
   * @generated from field: dxos.client.services.Invitation.AuthMethod auth_method = 2;
   */
  authMethod: Invitation_AuthMethod;

  /**
   * @generated from field: dxos.keys.PublicKey swarm_key = 3;
   */
  swarmKey?: PublicKey;

  /**
   * @generated from field: dxos.halo.credentials.SpaceMember.Role role = 4;
   */
  role: SpaceMember_Role;

  /**
   * / Present for AuthMethod.KNOWN_PUBLIC_KEY, where guess needs to prove possession of a corresponding private key
   *
   * @generated from field: optional dxos.keys.PublicKey guest_key = 5;
   */
  guestKey?: PublicKey;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_on = 6;
   */
  expiresOn?: Timestamp;

  /**
   * @generated from field: bool multi_use = 7;
   */
  multiUse: boolean;
};

/**
 * Describes the message dxos.halo.invitations.DelegateSpaceInvitation.
 * Use `create(DelegateSpaceInvitationSchema)` to create a new message.
 */
export const DelegateSpaceInvitationSchema: GenMessage<DelegateSpaceInvitation> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 7);

/**
 * @generated from message dxos.halo.invitations.CancelDelegatedInvitation
 */
export type CancelDelegatedInvitation = Message<"dxos.halo.invitations.CancelDelegatedInvitation"> & {
  /**
   * @generated from field: dxos.keys.PublicKey credential_id = 1;
   */
  credentialId?: PublicKey;
};

/**
 * Describes the message dxos.halo.invitations.CancelDelegatedInvitation.
 * Use `create(CancelDelegatedInvitationSchema)` to create a new message.
 */
export const CancelDelegatedInvitationSchema: GenMessage<CancelDelegatedInvitation> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 8);

/**
 * @generated from message dxos.halo.invitations.AdmissionRequest
 */
export type AdmissionRequest = Message<"dxos.halo.invitations.AdmissionRequest"> & {
  /**
   * @generated from oneof dxos.halo.invitations.AdmissionRequest.kind
   */
  kind: {
    /**
     * @generated from field: dxos.halo.invitations.DeviceAdmissionRequest device = 1;
     */
    value: DeviceAdmissionRequest;
    case: "device";
  } | {
    /**
     * @generated from field: dxos.halo.invitations.SpaceAdmissionRequest space = 2;
     */
    value: SpaceAdmissionRequest;
    case: "space";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dxos.halo.invitations.AdmissionRequest.
 * Use `create(AdmissionRequestSchema)` to create a new message.
 */
export const AdmissionRequestSchema: GenMessage<AdmissionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 9);

/**
 * @generated from message dxos.halo.invitations.DeviceAdmissionCredentials
 */
export type DeviceAdmissionCredentials = Message<"dxos.halo.invitations.DeviceAdmissionCredentials"> & {
  /**
   * @generated from field: dxos.keys.PublicKey identity_key = 1;
   */
  identityKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey halo_space_key = 2;
   */
  haloSpaceKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey genesis_feed_key = 3;
   */
  genesisFeedKey?: PublicKey;

  /**
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector control_timeframe = 4;
   */
  controlTimeframe?: TimeframeVector;

  /**
   * / Credential of type `AuthorizedDevice` that allows guest device to act as the identity it was added to.
   *
   * @generated from field: dxos.halo.credentials.Credential credential = 5;
   */
  credential?: Credential;

  /**
   * / Automerge URL of the halo space root document, so the joining device replicates the credential
   * / chain as a document rather than only as a control feed. Absent for a host that has not anchored.
   *
   * @generated from field: optional string halo_space_root_url = 6;
   */
  haloSpaceRootUrl?: string;
};

/**
 * Describes the message dxos.halo.invitations.DeviceAdmissionCredentials.
 * Use `create(DeviceAdmissionCredentialsSchema)` to create a new message.
 */
export const DeviceAdmissionCredentialsSchema: GenMessage<DeviceAdmissionCredentials> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 10);

/**
 * @generated from message dxos.halo.invitations.SpaceAdmissionCredentials
 */
export type SpaceAdmissionCredentials = Message<"dxos.halo.invitations.SpaceAdmissionCredentials"> & {
  /**
   * / Credential of type `SpaceMember` that grants Guest's identity access to the space.
   *
   * @generated from field: dxos.halo.credentials.Credential credential = 1;
   */
  credential?: Credential;

  /**
   * / Hint to the guest about the current control timeframe.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector control_timeframe = 2;
   */
  controlTimeframe?: TimeframeVector;

  /**
   * / Hint to the guest about the current data timeframe.
   *
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector data_timeframe = 3;
   */
  dataTimeframe?: TimeframeVector;
};

/**
 * Describes the message dxos.halo.invitations.SpaceAdmissionCredentials.
 * Use `create(SpaceAdmissionCredentialsSchema)` to create a new message.
 */
export const SpaceAdmissionCredentialsSchema: GenMessage<SpaceAdmissionCredentials> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 11);

/**
 * @generated from message dxos.halo.invitations.AdmissionResponse
 */
export type AdmissionResponse = Message<"dxos.halo.invitations.AdmissionResponse"> & {
  /**
   * @generated from oneof dxos.halo.invitations.AdmissionResponse.kind
   */
  kind: {
    /**
     * @generated from field: dxos.halo.invitations.DeviceAdmissionCredentials device = 1;
     */
    value: DeviceAdmissionCredentials;
    case: "device";
  } | {
    /**
     * @generated from field: dxos.halo.invitations.SpaceAdmissionCredentials space = 2;
     */
    value: SpaceAdmissionCredentials;
    case: "space";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dxos.halo.invitations.AdmissionResponse.
 * Use `create(AdmissionResponseSchema)` to create a new message.
 */
export const AdmissionResponseSchema: GenMessage<AdmissionResponse> = /*@__PURE__*/
  messageDesc(file_dxos_halo_invitations, 12);

/**
 * / Host service for two peers exchanging an invitation.
 * TODO(wittjosiah): Handle invitations where guest is the initiatating peer.
 * TODO(dmaretskyi): Rename to InvitationExtensionService.
 *
 * @generated from service dxos.halo.invitations.InvitationHostService
 */
export const InvitationHostService: GenService<{
  /**
   * / Both peers must call this method before any other.
   *
   * @generated from rpc dxos.halo.invitations.InvitationHostService.Options
   */
  options: {
    methodKind: "unary";
    input: typeof InvitationOptionsSchema;
    output: typeof EmptySchema;
  },
  /**
   * / Introduce guest to the host. Only on the host.
   *
   * @generated from rpc dxos.halo.invitations.InvitationHostService.Introduce
   */
  introduce: {
    methodKind: "unary";
    input: typeof IntroductionRequestSchema;
    output: typeof IntroductionResponseSchema;
  },
  /**
   * / Authenticate request. Only on the host.
   *
   * @generated from rpc dxos.halo.invitations.InvitationHostService.Authenticate
   */
  authenticate: {
    methodKind: "unary";
    input: typeof AuthenticationRequestSchema;
    output: typeof AuthenticationResponseSchema;
  },
  /**
   * / Process admission credentials. Only on the host.
   *
   * @generated from rpc dxos.halo.invitations.InvitationHostService.Admit
   */
  admit: {
    methodKind: "unary";
    input: typeof AdmissionRequestSchema;
    output: typeof AdmissionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_halo_invitations, 0);

